module.exports = __webpack_public_path__ + "img/mailing-empty.62f48cd7.png";